<ion-header class="absolute transparent">
    <app-header [middleIcon]="false" [hide930]="true" [backIcon]="false" [menuIcon]="false"></app-header>
</ion-header>
<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <div class="bg-header">
            <div class="wrap-logo">
                <img class="side-logo" src="../../../../assets/icon/veeam-logo-wide.svg">
                <div class="title" [@enter] *ngIf="type==='world'">{{ "__LEADERBOARD_WORLD_CHAMPIONSHIP__" | translate }}</div>
                <div class="title" [@enter] *ngIf="type==='hub'">{{ "__LEADERBOARD_HUB_CHAMPIONSHIP__" | translate }} - {{hubs[name].name}}</div>
                <div class="title" [@enter] *ngIf="type==='quiz'">{{ "__LEADERBOARD_QUIZ_MASTER__" | translate }} - {{hubs[name].name}}</div>
                <div class="title" [@enter] *ngIf="type==='sim'">{{ "__LEADERBOARD_MAGELLAN_PRIZE__" | translate }} - {{hubs[name].name}}</div>
            </div>
            <div class="table-header" [ngClass]="{'quiz-columns': type === 'quiz', 'sim-columns': type === 'sim'}">
                <div class="elem">{{ "__LEADERBOARD_POSITION__" | translate }}</div>
                <div class="left elem">{{ "__LEADERBOARD_NAME__" | translate }}</div>
                <div class="elem">{{ "__LEADERBOARD_LOCATION__" | translate }}</div>
                <div *ngIf="type !== 'quiz' && type !== 'sim'" class="bg-1 elem">{{ "__LEADERBOARD_PRE_EVENT__" | translate }}</div>
                <div *ngIf="type !== 'sim'" class="bg-2 elem">
                    <div class="line-1">{{ "__LEADERBOARD_ENABLEMENT_SESSION__" | translate }}</div>
                    <div class="line-2">
                        <div class="green box">1</div>
                        <div class="raspberry box">2</div>
                        <div class="blue box">3</div>
                        <div class="purple box">4</div>
                    </div>
                </div>
                <div *ngIf="type !== 'quiz' && type !== 'sim'" class="bg-3 elem">{{ "__LEADERBOARD_SOCIAL__" | translate }}</div>
                <div *ngIf="type !== 'quiz' && type !== 'sim'" class="bg-4 elem desktop-only">{{ "__LEADERBOARD_SIMULATION__" | translate }}</div>
                <div *ngIf="type !== 'quiz' && type !== 'sim'" class="bg-4 elem mobile-only">{{ "__LEADERBOARD_SIM__" | translate }}</div>
                <div class="elem">{{ "__LEADERBOARD_TOTAL__" | translate }}</div>
            </div>
        </div>
        <div class="shadow-container" *ngIf="!leaderboardData">
            <app-skeleton-leaderboard *ngFor="let el of ['50%','60%','40%','45%','50%','60%','40%','45%','50%','60%']; let i = index; let even = even"
                                      [ngClass]="{ even: even }" [even]="even" [width]="el"></app-skeleton-leaderboard>
        </div>
        <div class="shadow-container" *ngIf="!!leaderboardData">
            <div class="grid-line" *ngFor="let el of leaderboardData; let i = index; let even = even"
                 [@enter]="{ value: '', params: { delay: i * 20 } }"
                 [ngClass]="{ even: even, 'quiz-columns': type === 'quiz', 'sim-columns': type === 'sim'}">
                <div class="index" [ngClass]="{ dark: even }">{{i+1}}</div>
                <div class="left">{{el.full_name}}</div>
                <div [ngClass]="{'no-border': type === 'quiz'}" class="location">{{el.location}}</div>
                <div *ngIf="type !== 'quiz' && type !== 'sim'" class="no-border">{{el.pre_event}}</div>
                <div *ngIf="type !== 'sim'" class="green no-border">{{el.session1}}</div>
                <div *ngIf="type !== 'sim'" class="raspberry no-border">{{el.session2}}</div>
                <div *ngIf="type !== 'sim'" class="blue no-border">{{el.session3}}</div>
                <div *ngIf="type !== 'sim'" class="purple no-border">{{el.session4}}</div>
                <div *ngIf="type !== 'quiz' && type !== 'sim'">{{el.social}}</div>
                <div *ngIf="type !== 'quiz' && type !== 'sim'">{{el.sim}}</div>
                <div class="bold">{{type === 'quiz' ? el.total_quiz : type === 'sim' ?  el.sim : el.total}}</div>
            </div>
        </div>
    </div>
    <app-footer-logo [veeam]="true"></app-footer-logo>
</ion-content>
